package link.erpango.quip.data.firebase.messaging

import link.erpango.quip.data.firebase.IFirebaseClient

class FirebaseMessaging(
    private val client: IFirebaseClient
): IFirebaseMessaging {

    override fun getDeviceFCMToken(dataSourceListener: (String?) -> Unit) {
        //return client.getDeviceFCMToken(dataSourceListener)
    }

}